import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getLoggedInUser } from "../../../helpers/backend_helper";
import UserAvatar from "../UserAvatar";

const ProfileMenu = (props) => {
  const menuRef = useRef(null);
  const { pathname } = useLocation();
  useEffect(() => {
    if (menuRef.current) menuRef.current.open = false;
  }, [pathname]);
  useEffect(() => {
    const close = (event) => {
      if (event.type === "keydown" && event.key !== "Escape") return;
      if (
        event.type === "pointerdown" &&
        menuRef.current?.contains(event.target)
      )
        return;
      if (menuRef.current?.open) {
        menuRef.current.open = false;
        if (event.type === "keydown")
          menuRef.current.querySelector("summary")?.focus();
      }
    };
    document.addEventListener("pointerdown", close);
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("pointerdown", close);
      document.removeEventListener("keydown", close);
    };
  }, []);
  const [username, setUsername] = useState("User");
  const [account, setAccount] = useState(null);
  const roleName =
    account?.role?.name ||
    account?.roleName ||
    account?.userRole?.name ||
    account?.designation ||
    "";

  useEffect(() => {
    getLoggedInUser().then((data) => {
      setAccount(data || null);
      setUsername(data?.fullName || data?.name || "User");
    });
  }, [props.success]);

  if (props.displayOnly) {
    return (
      <div className="header-account-menu header-account-menu--display-only">
        <div className="header-profile-summary">
          <UserAvatar
            className="rounded-circle header-profile-user"
            user={account}
            alt={`${username} profile`}
          />
          <span className="header-profile-summary__identity d-none d-xl-flex">
            <strong>{username}</strong>
            {roleName && <small>{roleName}</small>}
          </span>
        </div>
      </div>
    );
  }

  return (
    <details className="header-account-menu" ref={menuRef}>
      <summary
        className="header-profile-summary"
        aria-label="Account navigation"
      >
        <UserAvatar
          className="rounded-circle header-profile-user"
          user={account}
          alt={`${username} profile`}
        />
        <span className="header-profile-summary__identity d-none d-xl-flex">
          <strong>{username}</strong>
          {roleName && <small>{roleName}</small>}
        </span>
        <FeatherIcon icon="chevron-down" />
      </summary>
      <nav className="header-account-menu__dropdown" aria-label="Account">
        {props.canSwitchFirm && <Link to="/switch-firm" onClick={(event) => {
          event.preventDefault();
          event.currentTarget.closest("details")?.removeAttribute("open");
          props.onSwitchFirm?.();
        }}><FeatherIcon icon="repeat" />Switch firm</Link>}
        <Link to="/profile">
          <FeatherIcon icon="user" />
          Profile
        </Link>
      </nav>
    </details>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  displayOnly: PropTypes.bool,
  canSwitchFirm: PropTypes.bool,
  onSwitchFirm: PropTypes.func,
};

const mapStatetoProps = () => ({ success: null });

export default connect(mapStatetoProps, {})(withTranslation()(ProfileMenu));
